<template>
  <div id="sign-up-page">

    <SignUpTabs class="c-max-w"/>

  </div>
</template>

<script>
import SignUpTabs from '@/components/settings/SignUpTabs.vue'
import { mapGetters } from "vuex";

export default {
  name: 'SignUpPage',
  components: {
    SignUpTabs,
  },
  metaInfo: {
    title: "Sign Up",
  },
  created() {
    if (this.getUser.loggedIn) {
      this.$router.push({ name: "Home" });
    }
  },
  computed: {
    ...mapGetters(["getUser"])
  },
}
</script>
